/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_AddressInputs */

const vi_shop_home_address = /** @type {(inputs: Shop_Home_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ`)
};

/**

* @param {Shop_Home_AddressInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_address = /** @type {((inputs?: Shop_Home_AddressInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_AddressInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_address(inputs)
});